/** Sampling for log lines that can fire per frame, chunk or keyframe
 *  request: the first `first` occurrences of a key are logged, after
 *  that every `every`-th with the running count — the log keeps the
 *  cause and the scale without one line per frame.
 *
 *  ```ts
 *  const repeat = this.decodeLog.hit('decode');
 *  if (repeat !== null) warn(`[receiver] decode failed${repeat}`, { err });
 *  ``` */
export class LogGate {
  private readonly counts = new Map<string, number>();

  constructor(
    private readonly first = 3,
    private readonly every = 500,
  ) {}

  /** Counts one occurrence of `key`. Returns `null` when it should not
   *  be logged, otherwise a suffix for the log line. */
  hit(key = ''): string | null {
    const n = (this.counts.get(key) ?? 0) + 1;
    this.counts.set(key, n);
    if (n < this.first) return '';
    if (n === this.first) return ' (further repeats are sampled)';
    return n % this.every === 0 ? ` (${n} times so far)` : null;
  }
}
